(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cross-collection-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!window.xrecQuickAddInitialized) {
    window.xrecQuickAddInitialized = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.xrec__form');

      if (!form) return;

      event.preventDefault();

      const button = form.querySelector('.xrec__add-button');
      const buttonText = button.querySelector('span');
      const status = form.querySelector('.xrec__status');
      const defaultText = button.dataset.defaultText;

      button.disabled = true;
      button.classList.remove('is-success', 'is-error');
      button.setAttribute('aria-busy', 'true');

      try {
        const action = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
        const response = await fetch(action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || button.dataset.errorText);
        }

        button.classList.add('is-success');
        buttonText.textContent = button.dataset.addedText;
        status.textContent = button.dataset.addedText;

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { product: result }
        }));
        document.dispatchEvent(new CustomEvent('xrec:cart:add', {
          bubbles: true,
          detail: { product: result }
        }));
      } catch (error) {
        button.classList.add('is-error');
        buttonText.textContent = button.dataset.errorText;
        status.textContent = error.message;
      } finally {
        button.removeAttribute('aria-busy');

        window.setTimeout(() => {
          button.disabled = false;
          button.classList.remove('is-success', 'is-error');
          buttonText.textContent = defaultText;
          status.textContent = '';
        }, 2200);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dya-hikayeler"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bolumler = document.querySelectorAll('[data-dya-vs]');
    if (!bolumler.length) return;
    bolumler.forEach(function (bolum) {
      if (bolum.dataset.hazir === '1') return;
      bolum.dataset.hazir = '1';
      var serit = bolum.querySelector('[data-serit]');
      if (!serit) return;
      var kartlar = Array.prototype.slice.call(serit.querySelectorAll('.dya-vs-kart'));
      var cubuklar = Array.prototype.slice.call(bolum.querySelectorAll('.dya-vs-cubuk'));
      var oklar = Array.prototype.slice.call(bolum.querySelectorAll('[data-ok]'));
      if (!kartlar.length) return;
      var aktif = 0, sesAcik = false, gorunur = false;

      function videoAl(i){ var k = kartlar[i]; return k ? k.querySelector('[data-video]') : null; }
      function hazirla(i){
        var v = videoAl(i);
        if (!v || v.dataset.bagli === '1') return;
        var kaynak = v.getAttribute('data-src');
        if (!kaynak) return;
        v.src = kaynak; v.dataset.bagli = '1'; v.load();
      }
      function oynat(i){
        var v = videoAl(i); if (!v) return;
        hazirla(i); v.muted = !sesAcik;
        var s = v.play(); if (s && s.catch) s.catch(function(){});
      }
      function durdurDigerleri(i){
        kartlar.forEach(function (k, j){
          if (j === i) return;
          var v = k.querySelector('[data-video]');
          if (v && !v.paused) v.pause();
        });
      }
      function cubuklariGuncelle(i){ cubuklar.forEach(function (c, j){ c.classList.toggle('aktif', j <= i); }); }
      function oklariGuncelle(i){
        oklar.forEach(function (o){
          var hedef = i + Number(o.getAttribute('data-ok'));
          o.hidden = hedef < 0 || hedef > kartlar.length - 1;
        });
      }
      function aktifYap(i){
        aktif = i;
        cubuklariGuncelle(i); oklariGuncelle(i); durdurDigerleri(i);
        hazirla(i + 1);
        if (gorunur) oynat(i);
      }

      if ('IntersectionObserver' in window) {
        var kartGozcu = new IntersectionObserver(function (girisler){
          girisler.forEach(function (g){
            if (g.isIntersecting && g.intersectionRatio > 0.6) aktifYap(kartlar.indexOf(g.target));
          });
        }, { root: serit, threshold: [0.61] });
        kartlar.forEach(function (k){ kartGozcu.observe(k); });

        var bolumGozcu = new IntersectionObserver(function (girisler){
          girisler.forEach(function (g){
            gorunur = g.isIntersecting;
            if (gorunur) oynat(aktif); else durdurDigerleri(-1);
          });
        }, { threshold: 0.25 });
        bolumGozcu.observe(bolum);
      } else {
        gorunur = true; aktifYap(0);
      }

      oklar.forEach(function (o){
        o.addEventListener('click', function (){
          var hedef = aktif + Number(o.getAttribute('data-ok'));
          if (hedef < 0 || hedef > kartlar.length - 1) return;
          serit.scrollTo({ left: kartlar[hedef].offsetLeft - serit.offsetLeft, behavior: 'smooth' });
        });
      });

      bolum.querySelectorAll('[data-ses]').forEach(function (dugme){
        dugme.addEventListener('click', function (olay){
          olay.preventDefault();
          sesAcik = !sesAcik;
          var v = videoAl(aktif); if (v) v.muted = !sesAcik;
          bolum.querySelectorAll('[data-ses]').forEach(function (d){
            d.setAttribute('aria-label', sesAcik ? 'Sesi kapat' : 'Sesi aç');
          });
        });
      });

      cubuklariGuncelle(0); oklariGuncelle(0); hazirla(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
